<!-- 首页面 登陆注册页面-->
<template>
  <el-container>
    <el-header height="100px">
      <div v-if="!loginOk" id="unLogin">
        <regDialog></regDialog><findPan></findPan>
      </div>
      <div v-if="loginOk" id="loginOk">
        <logoutDialog></logoutDialog>
      </div>
    </el-header>
    <el-main>
      <div id="libbox">
        <div>
           <img src="static/images/lib_title.png" />
        </div>
        <div style="margin-top: calc(5vh);">
             <div class="note_info_box">
<span class="libname">中国古代实用图库</span>是展示古人以图画形式认知世界（包括自然与人事）的可视数据库。共采集20万种典籍中的实用图画10万幅，可帮助今人完整、具象地认知古代中国。一库在手，阅尽风华。

             </div>
             <div class="note_info_box">
                  此次免费体验为<span class="libname">中国古代实用图库•山川城池编</span>的1%（300幅图），欢迎批评。<span id="xq" style="margin-left: 20px;"><a href="http://er07.com/home/pro_245.html" target="_blank">详情<span style="font-size: 23px;">>></span></a></span>
            </div>


        </div>
        <div id="login_bn">
         <loginNoUseLogin></loginNoUseLogin>
            <!--
          <div v-show="!loginByPw">
            <loginDialogByTel ref="child1" @changeLoginWayEvent="changeLoginWayFun"></loginDialogByTel>
          </div>
          <div v-show="loginByPw">
            <loginDialogByPw ref="child2" @changeLoginWayEvent="changeLoginWayFun"></loginDialogByPw>
          </div>
            -->
        </div>
      </div>
    </el-main>
    <el-footer height="30px">
      <pubfooter></pubfooter>
    </el-footer>
  </el-container>
</template>

<script>
import pubfooter from '@/components/public/footer'
import regDialog from '@/components/loginAndRegister/register/simpleRegDialog'
// import loginDialogByTel from '@/components/loginAndRegister/loginAndLogout/login/loginByTelAndMsgCode'
// import loginDialogByPw from '@/components/loginAndRegister/loginAndLogout/login/loginByTelAndPassword'

import loginNoUseLogin from '@/components/loginAndRegister/loginAndLogout/login/loginNoUseLogin'

import logoutDialog from '@/components/public/logout/logout'
import findPan from '@/components/loginAndRegister/findBackAccount'
export default {
  mounted () {
    // 清空检索值  到了检索页重新检索
    this.$store.commit('setGlobalSearchResult', [])
    this.$store.commit('setGlobalObjOfSearchKeyWords', '')

    this.$store.commit('setIndexViewBackgroundImgState', { imgOneValue: true, imgTwoValue: false }) // 切换首页的底图
    const api = '/md/front/user/loginStatus'
    this.axios.post(api).then(res => {
      if (res.status === 200) {
        this.$store.commit('setGlobalObjOfNowUserLoginState', res.data)
      }
    })
  },
  components: {
    pubfooter: pubfooter,
    logoutDialog: logoutDialog,
    // loginDialogByTel: loginDialogByTel,
    // loginDialogByPw: loginDialogByPw,
    findPan: findPan,
    regDialog: regDialog,
    loginNoUseLogin: loginNoUseLogin
  },
  data () {
    return {
      loginByPw: true
    }
  },
  methods: {
    changeLoginWayFun () { // fatherMethod
      this.loginByPw = !this.loginByPw
      if (this.loginByPw) {
        this.$refs.child2.loginCheck()
      } else {
        this.$refs.child1.loginCheck()
      }
    }
  },
  beforeUnmount () {
    this.$store.commit('setIndexViewBackgroundImgState', { imgOneValue: false, imgTwoValue: true })
  },
  computed: {
    loginOk () {
      return this.$store.state.globalObj.nowUserLoginState
    }
  }
}
</script>
<style scoped lang="less">
/* @import url(); 引入css类 */
.el-header {
  color: #333;
  text-align: center;
}
.el-footer {
  color: #333;
  text-align: center;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  text-align: center;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

#libbox {
  position: absolute;
  width: 100%;
  height: 120px;
  text-align: center;
  top: calc(22%);
  left: 0px;
}

#libbox img {
  position: relative;

}

#login_bn {
  margin-top: calc(10vh)
}

#unLogin {
  width: 300px;
  float: right;
}

#unLogin div {
  display: inline-block;
}

#loginOk {
  width: 150px;
  float: right;
  color: #fff;
}



.note_info_box {
    text-indent: 2em; /* 首行缩进 2 个字符 */
    width: 1050px;
    margin-left: auto;
    margin-right: auto;
    font-size: 28px;
    color: #fff;
    line-height: 50px;
    text-align:justify;
    font-family: 仿宋;
    font-weight: 500;
}

.libname {
    font-size: 35px;
    font-weight: 700;
}

#xq a {
    color: #fff;

    text-decoration: none;
}

#xq a:hover {
    position: relative;
    top: 1px;
    font-weight: 700;

}
</style>
